import moment from 'moment';

export const getCurrentTimeString = (timezone: string) => {
  return moment().tz(timezone).format('HH:mm:ss');
};
